import { ProductDepartmentEnum } from '../../../../products/enums/product-department-enum';
import { getWupDate } from '../../domain/shopping-cart-provider';
import React from 'react';
import { ICartItem } from '../../interfaces';
import { useAppSelector } from '../../data/store';

interface IOverviewTitle {
    cartItem: ICartItem,
    qa?: string,
}

const OverviewTitle = (props: IOverviewTitle) => {

    const { cartItem, qa } = props;
    const isInAppPurchase = useAppSelector(store => store.root.isInAppPurchase);
    const showLink = !!cartItem.documentUrlPath && !isInAppPurchase;

    return (
        <>
            <p>
                {
                    showLink &&
                    <a
                        href={ cartItem.documentUrlPath }
                        data-qa={ qa }
                        title=""
                        className="text-gray-700 no-underline">{ cartItem.skuName }</a>
                }

                { !showLink && <span data-qa={ qa }>{ cartItem.skuName }</span> }
            </p>
            {
                cartItem.skuDepartmentID === ProductDepartmentEnum.WavesUpdatePlan && getWupDate(cartItem) &&
                <p className="font-normal text-sm">({ getWupDate(cartItem) })</p>
            }
        </>
    )
};

export default OverviewTitle;